import React from 'react'
import { useSelector } from 'react-redux'
import './genres.scss'
function Genres({data}) {
   
    const {genre}=useSelector((state)=>state.home);
    
  return (
   <>
   <div className="genres">
    {data?.map((g)=>{
       
        if(!genre[g]?.name)return null;

        return(
        <div  key={g} className="genre">
            {genre[g]?.name}  
        </div>
          

        )
    })}
   </div>

   </>
  )
}

export default Genres
